import { render, staticRenderFns } from "./TenantOrOwner.vue?vue&type=template&id=31635b42&scoped=true"
import script from "./TenantOrOwner.vue?vue&type=script&lang=js"
export * from "./TenantOrOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31635b42",
  null
  
)

export default component.exports